import * as API from '@/services/API';
import StockImageService, { fallbackImages } from '@/services/StockImageService';

function stockImageQuery(vm) {
  const categories = ['home', 'mansion', 'residence', 'beach house'];
  const subcategories = [
    'exterior',
    'interior',
    'furniture',
    'living room',
    'kitchen',
    'garden',
    'room',
    'bedroom',
    'bathroom',
    'terrace',
    'garage',
    'pool',
  ];

  return `${vm.$faker().random.arrayElement(categories)} ${vm.$faker().random.arrayElement(subcategories)}`;
}

export default {
  getProperties({ commit }) {
    commit('SET_LOADING', true, { root: true });
    API.apiClient
      .get('/properties')
      .then((response) => {
        commit('SET_PROPERTIES', response.data);
        commit('SET_LOADING', false, { root: true });
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
        commit('SET_LOADING', false, { root: true });
      });
  },

  addProperty({ commit }, payload) {
    return API.apiClient.post('/properties', payload);
  },

  updateProperty({ commit, dispatch }, payload) {
    return API.apiClient
      .post('/properties/' + payload.id + '/amenities', payload.amenities)
      .then((response) => {
        delete payload.amenities;
        return API.apiClient
          .put('/properties/' + payload.id, payload)
          .then(() => {
            dispatch('amenities', payload.id);
          })
          .catch((error) => {
            commit('SET_ERROR', error, { root: true });
          });
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  viewProperty({ commit, dispatch }, propertyId) {
    return API.apiClient
      .get('/properties/' + propertyId)
      .then((response) => {
        commit('SET_CURRENT_PROPERTY', response.data);
        const property = response.data;
        const photo_gallery = property.gallery.find(({ type }) => type === 'photos');
        if (photo_gallery.id) {
          commit('galleries/SET_CURRENT_GALLERY', photo_gallery, { root: true });
          dispatch('galleries/getImages', photo_gallery, { root: true });
        }
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  amenityList({ commit, dispatch }, propertyId) {
    return API.apiClient
      .get('/amenities')
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  amenities({ commit, rootGetters }, propertyID) {
    if (!propertyID) {
      propertyID = rootGetters['properties/property'].id;
    }
    return API.apiClient
      .get('/properties/' + propertyID + '/amenities')
      .then((response) => {
        commit('SET_PROPERTY_AMENITIES', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  destroy({ commit }, propertyId) {
    return API.apiClient
      .delete('/properties/' + propertyId)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  async search({ commit, context }, payload) {
    commit('SET_LOADING', true);
    commit('SET_QUERY', payload);
    await API.apiClient
      .get('/properties/search', { params: payload })
      .then((response) => {
        commit('SET_SEARCH_RESULTS_CURRENT_PAGE', response.data.current_page);
        commit('SET_SEARCH_RESULTS_TOTAL', response.data.last_page);
        commit('SET_SEARCH_RESULTS', response.data.data);
        commit('SET_LOADING', false);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
        commit('SET_LOADING', false);
      });
  },

  async getPexelImage() {
    return StockImageService.search({ query: stockImageQuery(this._vm), per_page: 1 })
      .then((images) => (images[0] || fallbackImages()[0]).src.large2x)
      .catch(() => fallbackImages()[0].src.large2x);
  },

  async getPexelGallery() {
    return StockImageService.search({ query: stockImageQuery(this._vm), per_page: 10 })
      .then((images) => (images.length >= 5 ? images : fallbackImages(10)))
      .catch(() => fallbackImages(10));
  },

  async getStockImage({ dispatch }) {
    return dispatch('getPexelImage');
  },
};
